"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const hoc_1 = require("../../hoc");
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
class Input extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            passwordVisible: false,
            isFocus: false,
        };
        this.onFocus = (e) => {
            const { onFocus } = this.props;
            if (onFocus) {
                onFocus(e);
            }
            this.setState({ isFocus: true });
        };
        this.onBlur = (e) => {
            const { onBlur } = this.props;
            if (onBlur) {
                onBlur(e);
            }
            this.setState({ isFocus: false });
        };
        this.onToggleViewPassword = () => {
            const { onToggleViewPassword } = this.props;
            const { passwordVisible } = this.state;
            if (onToggleViewPassword) {
                this.setState({ passwordVisible: !passwordVisible }, () => {
                    onToggleViewPassword(!passwordVisible);
                });
            }
        };
        this.focus = () => {
            if (this.inputRef) {
                this.inputRef.focus();
            }
        };
        this.renderDropdown = () => {
            const { dropdown, visible } = this.props;
            if (visible && dropdown) {
                return dropdown;
            }
            return null;
        };
        this.renderAccessory = () => {
            const { accessory, error, viewPasswordImage, type, accessoryPosition, touched } = this.props;
            const { isFocus } = this.state;
            let imgSrc = null;
            let alt = '';
            if (accessory) {
                imgSrc = accessory.default;
                alt = 'accessory';
                if (isFocus) {
                    imgSrc = accessory.active;
                }
                if (!(0, lodash_1.isEmpty)(error) && touched) {
                    imgSrc = accessory.error;
                }
            }
            if (viewPasswordImage) {
                const images = {
                    password: viewPasswordImage.close.default,
                    text: viewPasswordImage.open.default
                };
                const errorImages = {
                    password: viewPasswordImage.close.error,
                    text: viewPasswordImage.open.error
                };
                const activeImages = {
                    password: viewPasswordImage.close.active,
                    text: viewPasswordImage.open.active
                };
                imgSrc = images[type];
                if (isFocus) {
                    imgSrc = activeImages[type];
                }
                if (!(0, lodash_1.isEmpty)(error) && touched) {
                    imgSrc = errorImages[type];
                }
            }
            if (imgSrc) {
                return ((0, core_1.jsx)("button", { type: "button", tabIndex: -1, onClick: () => {
                        if (viewPasswordImage) {
                            this.onToggleViewPassword();
                        }
                        else {
                            this.focus();
                        }
                    }, className: styles_scss_1.default.accessory, 
                    // eslint-disable-next-line react/no-unknown-property
                    css: styles_1.default.accessory({ accessoryPosition }) },
                    (0, core_1.jsx)("img", { className: styles_scss_1.default.accessoryImage, src: imgSrc, alt: alt })));
            }
            return null;
        };
        this.renderError = () => {
            const { error, touched } = this.props;
            if (error && touched) {
                return error;
            }
            return null;
        };
    }
    render() {
        const _a = this.props, { className, label, name, ariaLabel, error, touched, multiline, numberOfLines, type, staticLabel, testId } = _a, rest = __rest(_a, ["className", "label", "name", "ariaLabel", "error", "touched", "multiline", "numberOfLines", "type", "staticLabel", "testId"]);
        const { isFocus } = this.state;
        // Delete props that shouldn't be passed to the dom
        delete rest.visible;
        delete rest.success;
        delete rest.errorImage;
        delete rest.successImage;
        delete rest.requestClose;
        delete rest.viewPasswordImage;
        delete rest.onToggleViewPassword;
        delete rest.accessoryPosition;
        let inputText;
        const props = {
            'aria-label': ariaLabel,
            id: name,
            name,
            className: (0, carabiners_1.joinStr)(styles_scss_1.default.baseInput, className),
            css: styles_1.default.input({ success: false, error: !!error && touched }),
            onFocus: this.onFocus,
            onBlur: this.onBlur,
        };
        if (multiline) {
            inputText = (0, core_1.jsx)("textarea", Object.assign({ "data-testid": testId, ref: ref => {
                    this.inputRef = ref;
                }, rows: numberOfLines }, rest, props));
        }
        else {
            inputText = (0, core_1.jsx)("input", Object.assign({ "data-testid": testId, ref: ref => {
                    this.inputRef = ref;
                }, type: type }, rest, props));
        }
        return ((0, core_1.jsx)("div", { className: styles_scss_1.default.relative },
            (0, core_1.jsx)("div", { className: styles_scss_1.default.inputContainer },
                inputText,
                isFocus || staticLabel ? (
                // eslint-disable-next-line react/no-unknown-property
                (0, core_1.jsx)("small", { id: label, className: styles_scss_1.default.inputLabel, css: styles_1.default.label({ isFocus, error: !!error && touched }) }, label)) : null,
                (0, core_1.jsx)(__1.HelperText, { className: styles_scss_1.default.error }, this.renderError()),
                this.renderAccessory(),
                this.renderDropdown())));
    }
}
Input.defaultProps = {
    ariaLabel: '',
    type: 'text',
    dropdown: null,
    visible: false,
    error: '',
    touched: false,
    success: false,
    clean: null,
    onFocus: undefined,
    onBlur: undefined,
    onInput: undefined,
    className: null,
    accessory: null,
    label: '',
    requestClose: () => { },
    successImage: null,
    errorImage: null,
    maxLength: undefined,
    multiline: false,
    numberOfLines: 3,
    viewPasswordImage: null,
    onToggleViewPassword: undefined,
    accessoryPosition: 'right',
    staticLabel: false,
    testId: undefined
};
exports.default = (0, hoc_1.clickOutside)(Input);
